export enum PopUpTitle {
    vade = 1,
}

export enum PopUpTitleLabel {
    "Vade Tarihini girmeden ilerlemek istediğinizden emin misiniz?" = 1,
}